import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { STORAGE_KEYS } from '@constants/common';

export const useRedirectOnOrgSwitch = ({
	isReady,
	isAllowedHere,
	isGateReady = true,
	isConsumeFlagWhenAllowed = false,
}: {
	isReady: boolean;
	isAllowedHere: boolean;
	isGateReady?: boolean;
	isConsumeFlagWhenAllowed?: boolean;
}) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!isReady || !isGateReady) return;

		const hasOrgSwitchFlag = sessionStorage.getItem(STORAGE_KEYS.ORG_SWITCH_RELOAD_FLAG);

		if (!hasOrgSwitchFlag) return;

		if (!isAllowedHere) {
			sessionStorage.removeItem(STORAGE_KEYS.ORG_SWITCH_RELOAD_FLAG);
			navigate('/', { replace: true });

			return;
		}

		if (isConsumeFlagWhenAllowed) {
			sessionStorage.removeItem(STORAGE_KEYS.ORG_SWITCH_RELOAD_FLAG);
		}
	}, [isReady, isGateReady, isAllowedHere, navigate, isConsumeFlagWhenAllowed]);
};
